import React from 'react';
import { TWILIGHT_NAVY, LIVING_CORAL, SHELL_WHITE } from '../../../theme/colors';
import { FEATURES_HEADER, FEATURE_CARDS } from './featuresData';
import FeatureCardDesktop from './FeatureCardDesktop';

const FeaturesDesktop = () => (
  <div style={{ width: '100%', backgroundColor: SHELL_WHITE, padding: '80px 64px' }}>
    <div style={{ maxWidth: 1312, margin: '0 auto' }}>
      <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 600, marginBottom: 56 }}>
        <span style={{ fontFamily: 'DM Sans', fontSize: 12, fontWeight: 600, letterSpacing: '0.15em', textTransform: 'uppercase', color: LIVING_CORAL }}>
          {FEATURES_HEADER.eyebrow}
        </span>
        <span style={{ fontFamily: 'Instrument Serif', fontSize: 'clamp(28px, 3vw, 36px)', lineHeight: 1.25, color: TWILIGHT_NAVY, marginTop: 12 }}>
          {FEATURES_HEADER.headline}
        </span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 24 }}>
        {FEATURE_CARDS.map((feature) => (
          <FeatureCardDesktop key={feature.number} feature={feature} />
        ))}
      </div>
    </div>
  </div>
);

export default FeaturesDesktop;
